import { render, staticRenderFns } from "./ApplicationDetailsUploadedDocuments.vue?vue&type=template&id=4ff9dd2b&scoped=true&"
import script from "./ApplicationDetailsUploadedDocuments.vue?vue&type=script&lang=js&"
export * from "./ApplicationDetailsUploadedDocuments.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationDetailsUploadedDocuments.vue?vue&type=style&index=0&id=4ff9dd2b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff9dd2b",
  null
  
)

export default component.exports